import React from "react";
import { Table, Dropdown, Menu, Button, Card, Row, Col, Empty, Skeleton, message, Tooltip } from "antd";
import { CloudDownloadOutlined, MoreOutlined } from "@ant-design/icons";
import moment from "moment";

const FilesTable = ({ filesData, loading }) => {
  const menu = (
    <Menu>
      <Menu.Item key="1">Add Task Files</Menu.Item>
      <Menu.Item key="2">Delete Files</Menu.Item>
      <Menu.Item key="3">ZIP Files</Menu.Item>
      <Menu.Item key="3">Download All Files</Menu.Item>
    </Menu>
  );

  const getFileIcon = (fileName) => {
    const extension = fileName?.split(".").pop().toLowerCase();

    switch (extension) {
      case "pdf":
        return "https://locusbucket.s3.amazonaws.com/locustool/media/help_doc_file/PDF_file_icon.svg.png";
      case "doc":
      case "docx":
        return "https://locusbucket.s3.amazonaws.com/locustool/media/help_doc_file/docx_icon.svg.png";
      case "jpg":
      case "jpeg":
        return "https://locusbucket.s3.amazonaws.com/locustool/media/help_doc_file/jpeg-jpg.png";
      case "png":
        return "https://locusbucket.s3.amazonaws.com/locustool/media/help_doc_file/png1.webp";
      case "zip":
        return "https://locusbucket.s3.amazonaws.com/locustool/media/help_doc_file/zipppp.png";
      case "ppt":
      case "pptx":
        return "https://locusbucket.s3.amazonaws.com/locustool/media/help_doc_file/images_1.png";
      default:
        return "https://locusbucket.s3.amazonaws.com/locustool/media/help_doc_file/file-file-type.svg";
    }
  };

  const handleCopyAllLink = () => {
     try {
      const allFileUrls = filesData.map(file => file.file_url);
      const textToCopy = allFileUrls.join("\n");
      navigator.clipboard.writeText(textToCopy)
        .then(() => {
          message.success("All file links copied to clipboard!");
        })
        .catch((err) => {
          console.error("Failed to copy:", err);
        });
  
    } catch (err) {
      console.log("err", err);
    }
  };
  
  return (
    <div style={{ marginBottom: "20px" }}>
      <Card
        title={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span>Order Files</span>
            {/* <Dropdown overlay={menu} trigger={["click"]}>
              <Button shape="circle" icon={<MoreOutlined />} />
            </Dropdown> */}
            <Tooltip title="Click to generate shareable links for all files">
              {filesData.length > 0 && (
                <Button onClick={handleCopyAllLink}>
                  Generate File Links
                </Button>
              )}
            </Tooltip>
          </div>
        }
        style={{ marginBottom: "20px", textAlign: "left" }}
        headStyle={{ textAlign: "left" }}
      >
        {loading ? (
          <Skeleton active />
        ) : (
          <div
            style={{
              maxHeight: "300px",
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            {filesData && filesData.length > 0 ? (
              <Row gutter={[16, 16]}>
                {filesData.map((item, index) => (
                  <Col xs={24} sm={8} key={index}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        border: "1px solid #D3D3D3",
                        padding: "10px",
                        borderRadius: "10px",
                      }}
                    >
                      <div
                        style={{
                          height: "40px",
                          width: "40px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <img
                          style={{ height: "60px", width: "60px" }}
                          src={getFileIcon(item?.file_name)}
                          alt="file-icon"
                        />
                      </div>
                      <div style={{ flex: 1, marginLeft: "10px" }}>
                        <div
                          className="field-label"
                          style={{ fontWeight: "normal", wordBreak: "break-all" }}
                        >
                          {item?.file_name
                            ? item?.file_name.length <= 13
                              ? item?.file_name
                              : `${item?.file_name.slice(0, 13)}.${item?.file_name.split(".").pop()}`
                            : "No file name"}
                        </div>
                        <div style={{ color: "#555555" }}>
                          {moment(item?.created).format("DD-MM-YYYY hh:mm A")}
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "start",
                            gap: "20px",
                            marginTop: "5px",
                            color: "gray",
                          }}
                        >
                          <div>{item?.file_size} KB</div>
                          <div>
                            <a
                              href={item?.file_url}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <CloudDownloadOutlined style={{ fontSize: "19px", color: "gray" }} />
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            ) : (
              <Empty description="No Files Available" />
            )}
          </div>
        )}
      </Card>
    </div>
  );
};

export default FilesTable;
